import React from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import VoucherDocument from "./VoucherDocument";

import { useLocation, useNavigate } from "react-router-dom";

const VoucherPrint = () => {
  const location = useLocation();
  const voucherDataFromAPI = location.state?.jvPrintData || [];
  const voucherNoFromAPI = location.state?.jvNo || [];
  const voucherTypeFromAPI = location.state?.jvType || [];
  const voucherDateFromAPI = location.state?.jvDate || [];
  console.log("voucherDataFromAPI in print:", voucherDataFromAPI);

  const navigate = useNavigate();

  const onBack = () => {
    navigate("/voucherView");
  };

  return (
    <div className="mx-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl  my-4">Voucher Print</h2>
        <button
          className="text-white px-2 py-1 rounded  bg-gray-800 hover:bg-black "
          onClick={onBack}
        >
          Back
        </button>
      </div>

      <div className="flex flex-col items-center h-screen">
        <div className="w-full h-[75vh] border border-gray-300 mb-4">
          <PDFViewer width="100%" height="100%">
            <VoucherDocument voucherAccountData={voucherDataFromAPI} voucherNoFromAPI={voucherNoFromAPI} voucherTypeFromAPI={voucherTypeFromAPI} voucherDateFromAPI={voucherDateFromAPI}  />
          </PDFViewer>
        </div>

        <div className="mt-4 mb-6">
          <PDFDownloadLink
            document={
              <VoucherDocument voucherAccountData={voucherDataFromAPI} />
            }
            fileName="voucher.pdf"
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            {({ loading }) => (loading ? "Loading..." : "Download Voucher")}
          </PDFDownloadLink>
        </div>
      </div>
    </div>
  );
};

export default VoucherPrint;
